import { formatDate as formatDateType } from 'utils';

export const formatEntity = value => {
  if (!value) {
    return '--'
  }
  return <span id={value.id} className='text-capitalize'>
    {`[#${value.id}] ${value.name || value.first_name}`}
  </span>
}

export const formatJSON = value => {
  if (!value) {
    return '--'
  }
  return <pre className="formBuilder__builder m-0 p-0" style={{ maxHeight: 100, whiteSpace: 'pre-wrap', wordWrap: 'break-word', overflowY: 'auto' }}>
    {JSON.stringify(value || {}, null, 2)}
  </pre>
}

export const formatType = value => {
  if (!value) {
    return '--'
  }
  return DATA_TYPE[value]
}

export const formatDate = value => {
  if (!value) {
    return '--'
  }
  return formatDateType(value)
}

export const formatModalFields = value => <pre className="m-0 p-0 max-h-[100px] whitespace-pre-wrap wrap-break-word overflow-y-auto">
  {JSON.stringify(value || {}, null, 2)}
</pre>

export const formatModalType = value => DATA_TYPE[value]

export const COLORS = {
  to_process: 'neutral',
  waiting: 'neutral',
  processing: 'accent',
  finishing: 'accent',
  finished: 'success',
  expired: 'warning',
  error: 'danger',
  canceled: 'neutral',
}

export const DATA_TYPE = {
  subscriptions: "Sweeps Subscriptions",
  users: "Users",
  "impression-drilldown": "Impression Report",
  "losses-drilldown": "Pub Performance Report",
  "surveys-drilldown": "Survey Report",
  "integration-drilldown": "Integration Report",
  "siteVerification-drilldown": "Site Verifications Report",
  "ping-check-drilldown": "Ping Check Report",
}

export const STATUS_LABEL = {
  to_process: 'to process',
  processing: '1/2 processing',
  finishing: '2/2 processing',
}

export const DATE_MASK = {
  hour: 'MM/DD/YYYY [at] hh:mm A',
  day: 'MM/DD/YYYY',
  month: 'MM/YYYY',
}

